export const BACKEND_URL = "http://localhost:4050/api";
// export const BACKEND_URL = "https://mocker-backend.vercel.app/api";
